import { gql } from "@apollo/client";

export const UPDATE_PERSON_ORGANIZATION = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          organization
        }
      }
    }
  }
`;
export const UPDATE_PERSON_SID = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          sid
        }
      }
    }
  }
`;
export const UPDATE_PERSON_CELL = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          cell
        }
      }
    }
  }
`;
export const UPDATE_PERSON_PHONE = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          phone
        }
      }
    }
  }
`;
export const UPDATE_PERSON_EMAIL = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          email
        }
      }
    }
  }
`;
export const UPDATE_PERSON_DRIVERS_LICENSE = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          driversLicense
        }
      }
    }
  }
`;
export const UPDATE_PERSON_LICENSE_STATE = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          licenseState {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_IBR_GANG_AFFILIATIONS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          gangAffiliateds {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_IBR_RACE = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          ibrArresteeRaceType {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_EMPLOYER = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          employer
        }
      }
    }
  }
`;
export const UPDATE_PERSON_GROUP = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        groups {
          id
          oriId
          position
          name
        }
      }
    }
  }
`;

export const UPDATE_PERSON_FBI = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          fbiNumber
        }
      }
    }
  }
`;
export const UPDATE_PERSON_DECEASED = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          deceased
        }
      }
    }
  }
`;

export const UPDATE_PERSON_FIRSTNAME = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          firstName
        }
      }
    }
  }
`;

export const UPDATE_PERSON_MIDDLENAME = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          middleName
        }
      }
    }
  }
`;

export const UPDATE_PERSON_LASTNAME = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          lastName
        }
      }
    }
  }
`;

export const UPDATE_PERSON_SUFFIX = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          suffix
        }
      }
    }
  }
`;

export const UPDATE_PERSON_DOB = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          dob
        }
      }
    }
  }
`;

export const UPDATE_PERSON_GENDER = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          gender {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;

export const UPDATE_PERSON_NIBRS_GENDER = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          nibrsGender {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_RACE = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          race {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_ALIAS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          aliasName
        }
      }
    }
  }
`;
export const UPDATE_PERSON_DISTINGUISHING_CHARACTERISTICS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          distinguishingCharacteristics
        }
      }
    }
  }
`;
export const UPDATE_PERSON_BUILD = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          buildType {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_HAIR_COLOR = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          hairColor {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_EYE_COLOR = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          eyeColor {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_FACIAL_HAIR = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          facialHairType {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_HAIR_LENGTH = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          hairLength {
            id
            name
            oriId
            position
          }
        }
      }
    }
  }
`;

export const UPDATE_PERSON_JUVENILE = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          juvenile
        }
      }
    }
  }
`;
export const UPDATE_PERSON_HEIGHT = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          height
        }
      }
    }
  }
`;
export const UPDATE_PERSON_WEIGHT = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          weight
        }
      }
    }
  }
`;
export const UPDATE_PERSON_SCHOOL = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          school
        }
      }
    }
  }
`;

export const UPDATE_PERSON_HOME_ADDRESS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          homeAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_POB_ADDRESS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          pobAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_MAILING_ADDRESS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          mailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
              id
              notes
            }
            zip
          }
        }
      }
    }
  }
`;
export const UPDATE_PERSON_EMPLOYER_ADDRESS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        personalAttribute {
          id
          uuid
          employerAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
            zip
          }
        }
      }
    }
  }
`;

export const ADD_OR_UPDATE_PERSON_ALL_FIELDS = gql`
  mutation addOrUpdatePerson($input: AddOrUpdatePersonInput!) {
    addOrUpdatePerson(input: $input) {
      personUuid
      person {
        id
        uuid
        genericAttachments {
          attachmentType {
            id
            name
            oriId
            position
          }
          incident {
            id
            ori {
              id
            }
          }
          confidential
          dataUrl
          dataUrlWrapper
          description
          id
        }
        groups {
          id
          name
          oriId
          position
        }
        validPersonAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
          person {
            id
          }
        }
        personalAttribute {
          aliasName
          bilingual
          buildType {
            id
            name
            oriId
            position
          }
          cell
          deceased
          distinguishingCharacteristics
          dob
          driversLicense
          email
          employer
          employerAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
            zip
          }
          eyeColor {
            id
            name
            oriId
            position
          }
          facialHairType {
            id
            name
            oriId
            position
          }
          fbiNumber
          firstName
          fishWildlifeLicense
          gangAffiliateds {
            id
            name
            oriId
            position
          }
          gender {
            id
            name
            oriId
            position
          }
          hairColor {
            id
            name
            oriId
            position
          }
          hairLength {
            id
            name
            oriId
            position
          }
          height
          homeAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
            zip
          }
          ibrArresteeRaceType {
            id
            name
            oriId
            position
          }
          id
          juvenile
          lastName
          licenseState {
            id
            name
            oriId
            position
          }
          mailingAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
            zip
          }
          mentalHealthAlert
          middleName
          nibrsGender {
            id
            name
            oriId
            position
          }
          notes
          oldNames
          oldPhones
          organization
          phone
          pobAddress {
            city
            id
            lat
            lng
            name
            state
            streetName
            streetNumber
            unit
            uuid
            validAddressAlerts {
              alertType {
                id
                name
                alertLevel
                oriId
                position
              }
              expireAt
              id
              notes
              createdAt
              officer {
                deptAttribute {
                  id
                  badge
                  ori {
                    id
                    abbreviation
                  }
                }
                personalAttribute {
                  id
                  firstName
                  lastName
                }
              }
            }
            zip
          }
          race {
            id
            name
            oriId
            position
          }
          residentType {
            id
            name
            oriId
            position
          }
          sid
          substanceAbuseAlert
          suffix
          uuid
          violenceAlert
          waiverFine
          weaponsAlert
          weight
          work
        }
        photos {
          attachmentType {
            id
            name
            oriId
            position
          }
          confidential
          dataUrl
          dataUrlWrapper
          description
          id
        }
      }
      errors
    }
  }
`;
